import * as Rollbar from 'rollbar'

const rollbarConf = {
  accessToken: process.env.REACT_APP_ROLLBAR_API_KEY_CLIENT,
  captureUncaught: Boolean(process.env.REACT_APP_ROLLBAR_ACTIVE),
  captureUnhandledRejections: Boolean(process.env.REACT_APP_ROLLBAR_ACTIVE),
  enabled: Boolean(process.env.REACT_APP_ROLLBAR_ACTIVE),
  payload: {
    environment: process.env.NODE_ENV,
  },
  autoInstrument: {
    log: false,
  },
}

export const rollbar = new Rollbar(rollbarConf)



// WEBPACK FOOTER //
// ./src/utils/rollbar.ts